import { render, staticRenderFns } from "./PopularPackages.vue?vue&type=template&id=0bc35bd0&scoped=true&"
import script from "./PopularPackages.vue?vue&type=script&lang=js&"
export * from "./PopularPackages.vue?vue&type=script&lang=js&"
import style0 from "./PopularPackages.vue?vue&type=style&index=0&id=0bc35bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc35bd0",
  null
  
)

export default component.exports